export type Theme = 'light' | 'dark';

/** localStorage key of the chosen theme (stored as JSON, see utils/local-storage-service.ts). */
export const themeStorageKey = 'theme';

/** Bootstrap's color mode attribute, set on the <html> element. */
export const themeAttribute = 'data-bs-theme';
